/*
  VitalMart sticky add-to-cart bar (phones only, hidden on ≥750px by CSS).
  Mirrors the main product form: price, availability and label. Pressing it
  clicks the real Add to cart button, so variant choice and cart logic stay in Dawn.
*/
if (!customElements.get('vm-sticky-atc')) {
  customElements.define(
    'vm-sticky-atc',
    class VmStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.priceEl = this.querySelector('[data-vm-sticky-price]');
        this.button = this.querySelector('[data-vm-sticky-button]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.mainButton || !this.button) return;

        this.hidden = false;
        this.button.addEventListener('click', () => {
          const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          if (!main || main.disabled) return;
          main.click();
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', pastButton);
            this.setAttribute('aria-hidden', pastButton ? 'false' : 'true');
            this.button.tabIndex = pastButton ? 0 : -1;
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);
        this.setAttribute('aria-hidden', 'true');
        this.button.tabIndex = -1;

        this.sync();
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        this.mutationObserver = new MutationObserver(() => this.sync());
        if (priceContainer) this.mutationObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        this.mutationObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            window.requestAnimationFrame(() => {
              this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`) || this.mainButton;
              this.sync();
            });
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      sync() {
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (priceContainer && this.priceEl) {
          const price = priceContainer.querySelector('.price');
          let current = null;
          if (price && price.classList.contains('price--on-sale')) {
            current = price.querySelector('.price__sale .price-item--sale');
          }
          if (!current) current = priceContainer.querySelector('.price__regular .price-item--regular');
          if (current && current.textContent.trim()) this.priceEl.textContent = current.textContent.trim();
        }
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (main) {
          this.button.disabled = main.disabled;
          const label = main.querySelector('span');
          if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
        }
      }
    }
  );
}
